import { DataPage } from "@xbs/muon";
import { setAutoHeightToRow } from "../helpers/actions";
import { convertStyles, getCellIds, getCellInfo, getStylesObject } from "./../helpers/main";
import { IAction, IActionConfig, SpreadsheetEvents } from "./../types";
import { IGrid } from "@dhx/ts-grid";

declare const dhx: any;

export class SetCellStyle implements IAction {
	public config: IActionConfig;
	private _page: DataPage;
	private _page_rows: { height: number }[];

	constructor(config: IActionConfig) {
		this.config = config;
		this._page = config.page as DataPage;
	}

	do() {
		let { cell, val = "" , grid} = this.config;
		if (!cell) return;
		const { row, col } = getCellIds(cell, grid);

		const { locked, css = "" } = getCellInfo(cell, this._page, grid);
		if (locked) {
			return;
		}

		let multiline;

		if (typeof val !== "string") {
			multiline = val.multiline;
			const styles = getStylesObject(css.split("dhx_spreadsheet_link").join(" "));
			if (Array.isArray(val)) {
				val = val[0];
			}
			let css_string;
			if (typeof val !== "string") {

				if (this.config.replace) {
					css_string = dhx.css.add({ ...val });
				} else {
					css_string = dhx.css.add({ ...styles, ...convertStyles(val) });
				}
				val = css_string;
			}

			val = (css.includes("dhx_spreadsheet_link") ? "dhx_spreadsheet_link " : "") + css_string;
		}

		if (
			!this.config.spreadsheet?.events.fire(SpreadsheetEvents.beforeStyleChange, [
				cell,
				dhx.css.get(val),
			])
		) {
			return;
		}

		if (multiline) {
			this._page_rows = [...this._page.getMeta().rows];
			if (setAutoHeightToRow(cell, this.config.grid as IGrid, this._page, multiline)) {
				(this.config.spreadsheet as any)._updateGridState();
			}
		}

		this.config.prev = css;
		this._page.setCell(row, col, { css: val });

		this.config.spreadsheet.events.fire(SpreadsheetEvents.afterStyleChange, [cell, dhx.css.get(val)]);
		this.config.grid?.paint();
	}

	undo() {
		const val = this.config.val;
		const prev = this.config.prev;
		this.config.val = prev || "";
		this.config.prev = val || "";

		this.do();
		if (this._page_rows) {
			this._page.setMeta({ rows: this._page_rows });
			(this.config.spreadsheet as any)._updateGridState();
		}
		this.config.val = val;
		this.config.prev = prev;
	}
}
